import React from "react";
import { Button, Modal } from "react-bootstrap";
import { Form, Formik } from "formik";
import axios from "src/config/axios";
import FormTextArea from "src/components/Forms/FormTextArea";
import GeneralFormError from "src/components/Forms/GeneralFormError";
import { useTranslation } from "react-i18next";

const EditInternalNoteDialog = ({ stay, handleClose, handleSuccess }) => {
  const { t } = useTranslation("dashboard");

  function submit(values, { setSubmitting, setErrors }) {
    setSubmitting(true);

    axios
      .put(`/api/v1/stays/${stay.id}.json`, {
        stay: { internal_note: values.internal_note },
      })
      .then(() => {
        handleSuccess();
      })
      .catch((error) => {
        if (error?.response?.data) {
          setErrors(error.response.data);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  return (
    <Formik
      initialValues={{ internal_note: stay.internal_note ?? "" }}
      onSubmit={submit}
    >
      {({ errors, handleSubmit, isSubmitting }) => (
        <Modal
          show={true}
          onHide={handleClose}
          dialogClassName="edit-internal-note-dialog"
        >
          <Modal.Header>
            <Modal.Title>
              {t("booking_details.internal_note.label")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <GeneralFormError errors={errors} />
              <FormTextArea
                name="internal_note"
                label={t("booking_details.internal_note.label")}
                textareaClassName="internal-note-textarea"
              />
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("common:components:button.close")}
            </Button>
            <Button
              variant="primary"
              disabled={isSubmitting}
              onClick={handleSubmit}
            >
              {t("common:components:button.save")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Formik>
  );
};

export default EditInternalNoteDialog;
